import { Directive, ElementRef, HostListener, Input, Renderer2, AfterViewInit, ChangeDetectorRef } from '@angular/core';

@Directive({
	selector: '[appResizable]',
})
export class ResizableDirective {
	private startX: number;
	private startWidth: number;
	private mouseMoveListener: any;
	private mouseUpListener: any;
	@Input() localStorageKey: string;
	isCollapsed: boolean = false;
	constructor(private el: ElementRef, private renderer: Renderer2, private cdr: ChangeDetectorRef) {
		const resizer = this.renderer.createElement('div');
		this.renderer.addClass(resizer, 'resizer');
		this.renderer.appendChild(this.el.nativeElement, resizer);
		this.renderer.setStyle(this.el.nativeElement, 'position', 'relative');
		this.renderer.setStyle(this.el.nativeElement, 'min-width', '40px');
	}

	ngAfterViewInit() {
		const storedWidth = localStorage.getItem(this.localStorageKey);
		if (storedWidth) {
			console.log('setting width:', storedWidth);
			this.renderer.setStyle(this.el.nativeElement, 'width', storedWidth);
			//this.renderer.setStyle(this.el.nativeElement, 'background-color', '#ccc');
		}

		let icon = this.el.nativeElement.querySelector('i');
		if (!icon) {
			icon = this.renderer.createElement('div');
			this.renderer.appendChild(this.el.nativeElement, icon);
		}

		if (this.isCollapsed) {
			this.renderer.removeClass(icon, 'fa-caret-right'); // Adjust class as needed
			// Add classes for "collapsed" icon
			this.renderer.addClass(icon, 'fa');
			this.renderer.addClass(icon, 'fa-caret-left'); // Adjust class as needed
		} else {
			// Remove classes for "collapsed" icon
			this.renderer.removeClass(icon, 'fa-caret-left'); // Adjust class as needed
			// Add classes for "expanded" icon
			this.renderer.addClass(icon, 'fa');
			this.renderer.addClass(icon, 'fa-caret-right');
		}

		this.renderer.setStyle(icon, 'position', 'absolute');
		this.renderer.setStyle(icon, 'top', '50%');
		this.renderer.setStyle(icon, 'right', '-10px');
		this.renderer.setStyle(icon, 'transform', 'translate(-50%, -50%)');
		this.renderer.setStyle(icon, 'cursor', 'pointer');
		this.renderer.appendChild(this.el.nativeElement, icon);

		this.renderer.listen(icon, 'click', () => {
			if (this.isCollapsed) {
				this.renderer.setStyle(this.el.nativeElement, 'width', storedWidth);
			} else {
				this.renderer.setStyle(this.el.nativeElement, 'display', 'none');
			}
			this.isCollapsed = !this.isCollapsed;
		});
	}

	@HostListener('mousedown', ['$event']) onMouseDown(event: MouseEvent) {
		if ((event.target as Element).className.includes('resizer')) {
			this.startX = event.clientX;
			this.startWidth = this.el.nativeElement.offsetWidth;

			// Bind the methods once and store the reference
			this.mouseMoveListener = this.onMouseMove.bind(this);
			this.mouseUpListener = this.onMouseUp.bind(this);

			// Use the stored references to add event listeners
			window.addEventListener('mousemove', this.mouseMoveListener);
			window.addEventListener('mouseup', this.mouseUpListener);
		}
	}

	onMouseMove(event: MouseEvent) {
		const newWidth = this.startWidth + (event.clientX - this.startX);
		this.renderer.setStyle(this.el.nativeElement, 'width', `${newWidth}px`);
		this.disableTextSelection();
	}

	onMouseUp() {
		// Use the stored references to remove event listeners
		window.removeEventListener('mousemove', this.mouseMoveListener);
		window.removeEventListener('mouseup', this.mouseUpListener);

		// Store the new width in localStorage
		const newWidth = this.el.nativeElement.style.width;
		localStorage.setItem(this.localStorageKey, newWidth);
		this.enableTextSelection();
	}

	private disableTextSelection() {
		this.renderer.setStyle(document.body, 'user-select', 'none');
		this.renderer.setStyle(document.body, '-webkit-user-select', 'none');
		this.renderer.setStyle(document.body, '-moz-user-select', 'none');
		this.renderer.setStyle(document.body, '-ms-user-select', 'none');
	}

	private enableTextSelection() {
		this.renderer.removeStyle(document.body, 'user-select');
		this.renderer.removeStyle(document.body, '-webkit-user-select');
		this.renderer.removeStyle(document.body, '-moz-user-select');
	}
}
